var _Symbol$iterator = require('babel-runtime/core-js/symbol/iterator').default;

var _Object$assign = require('babel-runtime/core-js/object/assign').default;

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default').default;

(function () {
  Flint.file('mframework/decoratorFramework.js', function (require) {
    'use strict';

    var _immutable = require('immutable');

    var _immutable2 = _interopRequireDefault(_immutable);

    var _derivable = require('derivable');

    window.immutable = _immutable2.default;
    window.Record = _immutable2.default.Record;
    window.List = _immutable2.default.List;
    window.IMap = _immutable2.default.Map;
    window.atom = _derivable.atom;
    window.isDerivable = _derivable.isDerivable;
    window.derivation = _derivable.derivation;
    window.transact = _derivable.transact;
    window.lens = _derivable.lens;

    window.initPro = function (view, pro) {
      view.pro = pro;
      if (!view.pro.style) {
        view.pro.style = M.mergeAtom({});
      }
      if (!view.pro.children) {
        view.pro.children = (0, _derivable.atom)();
      }
      for (var propName in view.pro) {
        // Tag the pro atom/lens with its propName for debugging
        view.pro[propName].name = view.name + '.' + propName;
      }

      view._derivableProps = {};
      view._derivablePropReactors = {};

      var _loop = function (propName) {
        if (view.pro[propName]) {
          if ((0, _derivable.isDerivable)(view.props[propName])) {
            view._derivableProps[propName] = view.props[propName];
            view._derivablePropReactors[propName] = view.props[propName].reactor(function (propValue) {
              return view.pro[propName].set(propValue);
            });
            view._derivablePropReactors[propName].start().force();
          } else {
            view.pro[propName].set(view.props[propName]);
          }
        }
      };

      for (var propName in view.props) {
        _loop(propName);
      }

      return view.pro;
    };

    window.initContext = function (view, context) {
      view.mContext = context;
      for (var contextName in M.context) {
        view.mContext[contextName] = view.mContext[contextName] || (0, _derivable.atom)();
        view.mContext[contextName].name = view.name + '.mContext.' + contextName;
      }
      view.props.mContext.forEach(function (contextValue, contextName) {
        view.mContext[contextName].set(contextValue);
      });
      return view.mContext;
    };

    window.initData = function (view, data) {
      view._data = data;
      view.data = {};

      var _loop2 = function (dataKey) {
        // Shorthand for quickly mapping a Firebase ref into an atom
        if (typeof view._data[dataKey] == 'function' || view._data[dataKey] instanceof Array) {
          view._data[dataKey] = {
            ref: view._data[dataKey],
            value: true
          };
        }

        view.data[dataKey] = (0, _derivable.atom)();

        view._data[dataKey].derPathParts = (0, _derivable.derivation)(function () {
          if (typeof view._data[dataKey].ref == 'function') {
            var pathParts = view._data[dataKey].ref();
            if (!pathParts || pathParts.findIndex(function (pp) {
              return pp === undefined;
            }) >= 0) {
              return undefined;
            } else if (pathParts.findIndex(function (pp) {
              return !pp;
            }) >= 0) {
              throw new Error('Invalid path part for ' + view.name + '.data.' + dataKey + ':' + (' ' + JSON.stringify(pathParts)));
            } else {
              return List(pathParts);
            }
          } else {
            return List(view._data[dataKey].ref);
          }
        });

        view._data[dataKey].handlers = {}; // eventType: handler

        view._data[dataKey].refReactor = view._data[dataKey].derPathParts.reactor(function (pathParts) {
          var oldRef = view._data[dataKey].oldRef;

          var _loop4 = function (eventType) {
            var handler = view._data[dataKey].handlers[eventType];
            oldRef.off(eventType, handler);
            delete view._data[dataKey].handlers[eventType];

            // Bookkeeping for debugging
            var refKey = oldRef.toString().replace(/^.*firebaseio.com\//, '');
            var i = M._refs[refKey].findIndex(function (log) {
              return log.eventType == eventType && log.handler == handler;
            });
            M._refs[refKey].splice(i, 1);
            if (M._refs[refKey].length == 0) {
              delete M._refs[refKey];
            }
            // console.debug(`*off ${view.name} ${refKey} ${eventType}`)
          };

          for (var eventType in view._data[dataKey].handlers) {
            _loop4(eventType);
          }

          view.data[dataKey].set(undefined);

          var refOptions = view._data[dataKey].refOptions || function (ref) {
            return ref;
          };

          var ref = pathParts ? refOptions(M.ref.child(pathParts.join('/'))) : null;

          view._data[dataKey].oldRef = ref;

          if (!ref) return;

          var _loop5 = function (eventType) {
            if (['value', 'child_added', 'child_changed', 'child_moved', 'child_removed'].indexOf(eventType) >= 0) {
              var handler = ref.on(eventType, function (snapshot, prevChildKey) {
                if (eventType == 'value' && view._data[dataKey][eventType] === true) {
                  view.data[dataKey].set(snapshot.val());
                } else {
                  var returnValue = view._data[dataKey][eventType](snapshot, prevChildKey);

                  if (eventType == 'value') {
                    view.data[dataKey].set(returnValue);
                  }
                }
              });

              // Bookkeeping for debugging
              var refKey = ref.toString().replace(/^.*firebaseio.com\//, '');
              M._refs[refKey] = M._refs[refKey] || [];
              M._refs[refKey].push({ viewName: view.name, view: view, eventType: eventType, handler: handler });
              // console.debug(`on ${view.name}#${view.id} ${refKey} ${eventType}`)

              view._data[dataKey].handlers[eventType] = handler;
            }
          };

          for (var eventType in view._data[dataKey]) {
            _loop5(eventType);
          }
        }).start().force();
      };

      for (var dataKey in view._data) {
        _loop2(dataKey);
      }

      view.on.unmount(function () {
        if (view.debug) {
          console.log(view.name + '#' + view.id + ' on.unmount');
        }

        for (var dataKey in view._data) {
          view._data[dataKey].refReactor.stop();

          var oldRef = view._data[dataKey].oldRef;

          var _loop3 = function (eventType) {
            var handler = view._data[dataKey].handlers[eventType];
            oldRef.off(eventType, handler);
            delete view._data[dataKey].handlers[eventType];

            // Bookkeeping for debugging
            var refKey = oldRef.toString().replace(/^.*firebaseio.com\//, '');
            var i = M._refs[refKey].findIndex(function (log) {
              return log.eventType == eventType && log.handler == handler;
            });
            M._refs[refKey].splice(i, 1);
            if (M._refs[refKey].length == 0) {
              delete M._refs[refKey];
            }
            // console.debug(`off ${view.name}#${view.id} ${refKey} ${eventType}`)
          };

          for (var eventType in view._data[dataKey].handlers) {
            _loop3(eventType);
          }
        }
      });

      return view.data;
    };

    var nextId = 0;
    window.views = {};

    var decorator = function decorator(view) {
      if (['Installer', 'Modal', 'Menu', 'Errors'].indexOf(view.name) >= 0) {
        // Ignore special Flint components
        return;
      }

      nextId += 1;
      view.id = nextId;

      view._syncUpdate = view.update;
      view._asyncUpdate = function () {
        if (view._willUpdate) return;
        view._willUpdate = true;

        setTimeout(function () {
          view._syncUpdate();
          view._willUpdate = false;
        }, 1);
      };
      view.update = function () {
        // The only place that calls this is Flint's rerendering pathway, which
        // we want to turn into a no-op because we have our own rerendering
        // pathway
        if (view.debug) {
          console.info('Flint tried to call view.update on', view.name);
        }
      };

      if (!view.pro) {
        initPro(view, {});
      }

      if (view.name != 'Main' && !view.mContext) {
        initContext(view, {});
      }

      var addContextToTree = function addContextToTree(tree) {
        var contextValues = undefined;
        if (view.name == 'Main') {
          contextValues = {};
          for (var contextName in M.context) {
            contextValues[contextName] = M.context[contextName].get();
          }
          contextValues = IMap(contextValues);
        } else {
          contextValues = view.props.mContext;
        }

        if (tree instanceof Array || tree && typeof tree == 'object' && (tree instanceof List || window.Symbol && tree[_Symbol$iterator])) {
          return tree.map(addContextToTree);
        } else if (tree && typeof tree == 'object') {
          var newTree = _Object$assign({}, tree);
          newTree.props = _Object$assign({ mContext: contextValues }, newTree.props);
          if (newTree.props.children) {
            newTree.props.children = addContextToTree(newTree.props.children);
          }
          return newTree;
        } else {
          return tree;
        }
      };

      var contentMakers = view.renders.length ? view.renders : [
      // We need at least one fake render to do the auto-style-dependency-tracking
      // below. Flint's RadiumEnhancer code gets weird about one render function
      // returning null so we'll make two.
      function () {
        return null;
      }, function () {
        return null;
      }];
      var NOT_RENDERING_YET = {};

      var renderDerivations = contentMakers.map(function (contentMaker, i) {
        var renderDerivationI = (0, _derivable.derivation)(function () {
          if (view.isRendering) {
            if (view.debug) {
              console.log('Render ' + view.name + '#' + view.id + '[' + i + ']');
            }

            var tree = contentMaker.call(view);

            // In case contentMaker never calls pro.style.get(), call it here to
            // register the dependency that the view's container needs to rerender
            // when the parent changes its style.
            view.pro.style.get();

            if (view.debug) {
              console.log('Add context to ' + view.name + '#' + view.id + '[' + i + ']', tree);
            }

            // Call these getters to set up a dependency between every component's
            // render function and its view of the context.
            for (var contextName in M.context) {
              if (view.name == 'Main') {
                M.context[contextName].get();
              } else {
                view.mContext[contextName].get();
              }
            }

            return addContextToTree(tree);
          } else {
            if (view.debug) {
              console.log('Premature ' + view.name + '#' + view.id + '[' + i + ']');
            }
            renderDerivationI.fakeEntropy.get();
            view._asyncUpdate();
            return NOT_RENDERING_YET;
          }
        });

        renderDerivationI.fakeEntropy = (0, _derivable.atom)(0);

        return renderDerivationI;
      });

      view.renders = renderDerivations.map(function (d, i) {
        return function () {
          var dValue = d.get();
          var tree = undefined;
          if (dValue === NOT_RENDERING_YET) {
            d.fakeEntropy.set(d.fakeEntropy.get() + 1);
            tree = d.get();
          } else {
            tree = dValue;
          }
          if (view.debug) {
            console.log('Tree for ' + view.name + '#' + view.id + '[' + i + ']', tree);
          }
          return tree;
        };
      });

      var renderReactors = renderDerivations.map(function (d, i) {
        return d.reactor(function () {
          view._asyncUpdate();
        });
      });

      view.on.mount(function () {
        window.views[view.id] = view;
        renderReactors.forEach(function (reactor) {
          return reactor.start();
        });
      });

      view.on.unmount(function () {
        renderReactors.forEach(function (reactor) {
          return reactor.stop();
        });
        delete window.views[view.id];
      });

      view.on.props(function () {
        if (view.debug) {
          console.info(view.name, view.id, 'on props', view.props, view.isRendering, view.mounted);
        }

        // Update view.pro atoms
        if (!view.mounted) {
          if (!view.firstRender && view.debug) {
            console.log('Ignoring ' + view.name + '#' + view.id + '.on.props');
          }
          return;
        }

        (0, _derivable.transact)(function () {
          if (view.pro) {
            var _loop6 = function (propName) {
              if (view.pro[propName]) {
                var oldDerivable = view._derivableProps[propName];

                if (oldDerivable && view.props[propName] === oldDerivable) {
                  // No-op

                } else {
                    if (oldDerivable) {
                      view._derivablePropReactors[propName].stop();
                      delete view._derivablePropReactors[propName];
                      delete view._derivableProps[propName];
                    }

                    if ((0, _derivable.isDerivable)(view.props[propName])) {
                      view._derivableProps[propName] = view.props[propName];
                      view._derivablePropReactors[propName] = view.props[propName].reactor(function (propValue) {
                        return view.pro[propName].set(propValue);
                      });
                      view._derivablePropReactors[propName].start().force();
                    } else {
                      view.pro[propName].set(view.props[propName]);
                    }
                  }
              }
            };

            for (var propName in view.props) {
              _loop6(propName);
            }
          }
          if (view.mContext) {
            view.props.mContext.forEach(function (contextValue, contextName) {
              if (contextName in view.mContext) {
                if (view.debug) {
                  console.log('Set context on ' + view.name + '#' + view.id + ': ' + (contextName + '=' + JSON.stringify(contextValue)));
                }
                view.mContext[contextName].set(contextValue);
              }
            });
          }
        });
      });

      view.shouldUpdate(function () {
        return false;
      });

      view.findId = function (elemId) {
        var domNode = ReactDOM.findDOMNode(view);
        return domNode.getElementsByTagName(elemId)[0] || domNode.getElementsByClassName(elemId)[0];
      };
    };

    Flint._onViewInstance(decorator);
  })
})();
//# sourceMappingURL=decoratorFramework.js.map
